app.component("ovd", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/ovd/ovd.html",
	controller: "ovdController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("ovdController", [
	"$scope",
	"OVD",
	function ($scope, OVD) {
		$scope.otherOvdArray = [];
		$scope.warn_ovd = false;


		$scope.removeOther = function (index) {
			$scope.otherOvdArray.splice(index, 1);
			// Rebuild the joined "Other" entry, otherwise the removed OVD is still saved.
			if ($scope.$ctrl.data) {
				$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
					if (item === "Other" && $scope.otherOvdArray.length > 0) return getOtherOvdArrayString($scope.otherOvdArray);
					return item;
				});
			}
		};

		$scope.selection = [];


		this.$onChanges = function (changesObj) {
			if (changesObj.data?.currentValue) {
				$scope.OVD = $scope.OVD.map((t) => ({ ...t, selected: false }));
				$scope.otherOvdArray = [];
				if (changesObj.data.currentValue.ovd && changesObj.data.currentValue.ovd.length > 0) {
					changesObj.data.currentValue.ovd.forEach((element) => {
						const obj = $scope.OVD.find((t) => t.value === element);
						if (obj) {
							obj.selected = true;
						} else {
							$scope.OVD.find((t) => t.value === "Other").selected = true;
							$scope.otherOvdArray = element.split(",");
							// $scope.otherOvd = element;
						}
					});
				}
			}
		};

		$scope.$watch(
			"OVD|filter:{selected:true}",
			function (newValue) {
				$scope.selection = newValue.map(function (item) {
					return item.value;
				});
				if ($scope.$ctrl.data) {
					$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
						if (item === "Other") {
							$scope.warn_ovd = false;
						}
						if (item === "Other" && $scope.otherOvdArray.length > 0) return getOtherOvdArrayString($scope.otherOvdArray);
						return item;
					});
				}
			},
			true
		);

		function getOtherOvdArrayString(array) {
			let str = "";
			array.forEach((element, index) => {
				str = str + element;
				if (index !== array.length - 1) {
					str = str + ",";
				}
			});
			return str;
		}

		$scope.form_other = { value: "" };

		$scope.addOther = function () {
			if ($scope.form_other.value && $scope.form_other.value.length > 2 && $scope.form_other.value.length < 41) {
				$scope.otherOvdArray.push($scope.form_other.value);
				$scope.$ctrl.data.ovd = $scope.selection.map(function (item) {
					if (item === "Other") return getOtherOvdArrayString($scope.otherOvdArray);
					return item;
				});
				$scope.warn_ovd = false;
				$scope.form_other.value = "";
			}
		};

		$scope.OVD = OVD.map((t) => ({ ...t, selected: false }));

		$scope.showWarn_ovd = function () {
			$scope.warn_ovd = true;
		};
	},
]);
